<vdr-facet-value-selector
  [readonly]="readonly"
  [formControl]="formControl"
  [transformControlValueAccessorValue]="valueTransformFn"
></vdr-facet-value-selector>
